import React from 'react'
import { Link } from 'react-router-dom'
import styles from './Contact.module.css'

const Contact = () => {
    return (
        <div className={styles.container}>
            <div className={styles.box}></div>
            <header>
                <Link to="/terms"><h1>Contact Us</h1></Link>
            </header>

            <main>
                <p>Let us know your feedback, queries or issues regarding app or features.</p>
                <div className={styles.row}>
                    <h2>Full Name</h2>
                    <input type="text" name="name" placeholder="Enter your name" />
                </div>
                <div className={styles.row}>
                    <h2>Email Address</h2>
                    <input type="email" name="email" placeholder="Enter your email" />
                </div>
                <div className={styles.row}>
                    <h2>Phone Number</h2>
                    <input type="text" name="number" placeholder="Enter your phone number" />
                </div>
            </main>

        </div>
    )
}

export default Contact
